export default {
  testApiMsg: state => state.testApiMsg,
  notice: state => state.notice,
  notices: state => state.notices,
  initDataPending: state => state.initDataPending,
  exchangeRate: state => state.exchangeRate,
  headline: state => state.headline,
  breadcrumbs: state => state.breadcrumbs,
  menuMobile: state => state.menuMobile,
  searchMobile: state => state.searchMobile,
  filtersMobile: state => state.filtersMobile,
  categories: state => state.categories,
  filters: state => state.filters,
  category: state => state.category,
  categoryFilters: state => state.category.filters,
  categoryPage: state => state.category.page,
  categoryPerPage: state => state.category.perPage,
  categorySort: state => state.category.sort,
  categoryViewMode: state => state.category.viewMode,
  products: state => state.category.products,
  product: state => state.product,
  galleryModal: state => state.galleryModal,
  cart: state => state.cart,
  cartLastItemName: state => {
    if (state.cart.items.length) {
      const item = state.cart.items[state.cart.items.length - 1]
      // TODO: name_${locale} || name
      return item
    }
    return ''
  },
  addedCartNotice: state => state.cart.addedNotice,
  order: state => state.order,
  delivery: state => state.delivery,
  payment: state => state.payment,
  posts: state => state.blog.posts,
  postPage: state => state.blog.page,
  postPerPage: state => state.blog.perPage,
  franchise: state => state.franchise,
  lang: state => state.lang,
}
